import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TransactionWrapper').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    height: '80px',
    borderRadius: '8px',
    background: theme.colors.button.secondary.background,
    padding: '12px 8px',
  },

  idAndAmountWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },

  paymentTypeAndIdWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },

  paymentTypeText: {
    fontSize: theme.sizes.texts.fontSize.s,
    lineHeight: '14px',
    fontWeight: 350,
    color: theme.colors.text.secondary,
  },

  idText: {
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: '17px',
    fontWeight: 350,
    color: theme.colors.text.primary,
  },

  amountAndCurrencyWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',

    img: {
      width: '28px',
    },
  },

  amountText: {
    fontFamily: 'Space Grotesk',
    fontWeight: 440,
    fontSize: '22px',
    lineHeight: theme.sizes.texts.lineHeight.l,
    color: theme.colors.text.primary,
  },

  statusAndTimeWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '32px',
  },

  statusWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
  },

  statusText: {
    fontWeight: 350,
    fontSize: '13px',
    lineHeight: '13px',
    color: theme.colors.text.secondary,

    '&[data-status="PAID"]': {
      color: theme.colors.text.success,
    },
    '&[data-status="FAILED"]': {
      color: theme.colors.text.error,
    },
    '&[data-status="PENDING"]': {
      color: theme.colors.text.golden,
    },
  },

  topContainerStatusWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },

  statusVariantText: {},

  timeText: {},

  drawerContent: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    paddingBottom: '6px',
    borderBottom: '1px solid',
    borderColor: theme.colors.borders.default,
  },

  drawerContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '0px 12px',
  },

  propertyText: {
    color: theme.colors.text.secondary,
    fontWeight: 250,
    fontSize: theme.sizes.texts.fontSize.s,
  },
  valueText: {
    color: theme.colors.text.primary,
    fontWeight: 250,
    fontSize: theme.sizes.texts.fontSize.s,
  },

  leftText: {
    fontFamily: 'Inter',

    fontWeight: '450',
    color: theme.colors.text.secondary,

    fontSize: '14px',
  },

  rightText: {
    fontFamily: 'Inter',

    fontWeight: '450',
    color: theme.colors.text.primary,

    fontSize: '14px',
  },
}))
